import { Colors, Services } from '@sigma-frontend-libs/commons'
import { NOTIFICATIONS_AVAILABLE_TYPES } from '@sigma-legacy-libs/essentials/lib/constants'

import { buttonModes, components, icons, sizes } from '@/utils'

import button from '@/components/button'
import info from '@/components/info'

function renderTitleField(h) {
  if (~[ 'web', 'email' ].indexOf(NOTIFICATIONS_AVAILABLE_TYPES[this.channel])) {
    return h(
      components['text-field'],
      {
        props: {
          value: this.data.subject,
          label: this.getTranslate(`${Services.notifications}.labels.subject`),
          details: false,
          clearable: true
        },
        on: {
          input: event => {
            this.data.subject = event
          }
        }
      }
    )
  }
}
function renderBodyField(h) {
  return h(
    components.textarea,
    {
      class: { 'mt-1': this.viewport.breakpoint.mdUp },
      props: {
        value: this.data.body,
        label: this.getTranslate(`${Services.notifications}.labels.body`),
        rows: 8,
        grow: true,
        clearable: false,
        details: false
      },
      on: {
        input: event => {
          this.data.body = event
        }
      }
    }
  )
}
function renderInfoDialog(h) {
  return h(
    components.dialog,
    {
      props: {
        value: this.showDialog,
        title: this.getTranslate(`${Services.notifications}.titles.variables`),
        maxWidth: this.$_dialogMaxWidth
      },
      on: {
        input: event => {
          this.showDialog = event
        }
      }
    },
    [
      h(
        'div',
        {
          class: 'documentation-content pa-3',
          domProps: { innerHTML: this.html }
        }
      ),
      h(
        'div',
        {
          class: 'dialog__footer',
          slot: 'footer'
        },
        [
          h(
            button,
            {
              props: {
                label: this.getTranslate('misc.buttons.close'),
                mode: buttonModes.flat

              },
              on: {
                click: () => {
                  this.showDialog = false
                }
              }
            }
          )
        ]
      )
    ]
  )
}
function renderInfo(h) {
  return h(
    info,
    {},
    [
      h(
        'div',
        {
          class: 'grid grid-gap--8'
        },
        [
          this.getTranslate(`${Services.notifications}.hints.variables`),

          h(
            'div',
            {
              class: 'fjcfe'
            },
            [
              h(
                button,
                {
                  props: {
                    label: this.getTranslate('misc.buttons.documentation'),
                    mode: buttonModes.flat,
                    size: sizes.small,
                    color: Colors.primary
                  },
                  scopedSlots: {
                    dialog: () => {
                      return renderInfoDialog.call(this, h)
                    }
                  },
                  on: {
                    click: () => {
                      this.showDialog = true
                    }
                  }
                }
              )
            ]
          )
        ]
      )
    ]
  )
}
function renderForm(h) {
  return h(
    components.form,
    {
      class: {
        grid: true,
        'grid-gap--8': this.viewport.breakpoint.mdUp,
        'grid-gap--12': !this.viewport.breakpoint.mdUp
      }
    },
    [
      renderTitleField.call(this, h),
      renderBodyField.call(this, h),
      renderInfo.call(this, h)
    ]
  )
}
function renderPreview(h) {
  return h(
    components.card,
    {
      class: 'pxpx-12 py-2',
      props: {
        title: this.getTranslate('misc.preview'),
        outline: true,
        rounded: true
      }
    },
    [
      h(
        'div',
        {
          domProps: {
            innerHTML: this.data.body
          }
        }
      )
    ]
  )
}
function renderBody(h) {
  if (this.data) {
    let bodyGridColumns
    if (this.viewport.breakpoint.mdUp) {
      bodyGridColumns = '1fr 1fr'
    } else {
      bodyGridColumns = '1fr'
    }

    return h(
      'div',
      {
        class: {
          'grid pt-2 px-2': true,
          'grid-gap--8': this.viewport.breakpoint.mdUp,
          'grid-gap--12': !this.viewport.breakpoint.mdUp
        },
        style: { gridTemplateColumns: bodyGridColumns }
      },
      [
        renderForm.call(this, h),
        renderPreview.call(this, h)
      ]
    )
  }
}

function renderFooter(h) {
  return h(
    'div',
    {
      class: 'dialog__footer',
      slot: 'footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            mode: buttonModes.flat
          },
          on: {
            click: () => {
              this.proxy = false
            }
          }
        }
      ),
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.save'),
            icon: icons.save,
            color: Colors.primary,
            mode: buttonModes.filled
          },
          on: {
            click: () => {
              this.submit()
            }
          }
        }
      )
    ]
  )
}

export default function(h) {
  return h(
    components.dialog,
    {
      props: {
        value: this.proxy,
        title: this.getTranslate(this.title),
        maxWidth: this.$_dialogMaxWidth
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    },
    [
      renderBody.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}
